import { Fragment } from "react";
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import HeadquarterPickups from "./HeadquarterPickups";

const HeadquarterPickupsWrapper = () => {
    const defaultFilters = {};

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <HeadquarterPickups />
            </FiltersProvider>
        </Fragment>
    );
};

export default HeadquarterPickupsWrapper;